import { ServiceWorkerState } from '@office-start/common-types';
export function applyCommonStateParams(params, currentPage, initialPage, serviceWorkerState, securityLevel, networkType) {
    if (!params.hasOwnProperty("Page" /* Page */)) {
        params["Page" /* Page */] = currentPage || 'Unknown';
    }
    if (!params.hasOwnProperty("InitialPage" /* InitialPage */)) {
        params["InitialPage" /* InitialPage */] = initialPage || 'Unknown';
    }
    if (!params.hasOwnProperty("ServiceWorkerState" /* ServiceWorkerState */)) {
        params["ServiceWorkerState" /* ServiceWorkerState */] =
            serviceWorkerState || ServiceWorkerState.Unknown;
    }
    if (!params.hasOwnProperty("AppSecurityLevel" /* AppSecurityLevel */)) {
        params["AppSecurityLevel" /* AppSecurityLevel */] = securityLevel.toString();
    }
    if (!params.hasOwnProperty("NetworkType" /* NetworkType */)) {
        params["NetworkType" /* NetworkType */] = networkType;
    }
}
//# sourceMappingURL=applyCommonStateParams.js.map